module.exports = __webpack_public_path__ + "img/pocket_jp.b8b5bce.jpg";